//https://gist.github.com/kurtmilam/1868955
//same as _.extend, except it work with more than one level
__.mixin({ 'deepExtend': function(obj){
	var parentRE = /#{\s*?_\s*?}/,
	slice = Array.prototype.slice;

	__.each(slice.call(arguments, 1), function(source) {
		for (var prop in source) {
			if (__.isUndefined(obj[prop]) || __.isFunction(obj[prop]) || __.isNull(source[prop]) || __.isDate(source[prop])) {
				obj[prop] = source[prop];
			}
			else if (__.isString(source[prop]) && parentRE.test(source[prop])) {
				if (__.isString(obj[prop])) {
					obj[prop] = source[prop].replace(parentRE, obj[prop]);
				}
			}
			else if (__.isArray(obj[prop]) || __.isArray(source[prop])){
				if (!__.isArray(obj[prop]) || !__.isArray(source[prop])){
					throw new Error('Trying to combine an array with a non-array (' + prop + ')');
				} else {
					obj[prop] = __.reject(__.deepExtend(__.clone(obj[prop]), source[prop]), function (item) { return __.isNull(item);});
				}
			}
			else if (__.isObject(obj[prop]) || __.isObject(source[prop])){
				if (!__.isObject(obj[prop]) || !__.isObject(source[prop])){
					throw new Error('Trying to combine an object with a non-object (' + prop + ')');
				} else {
					obj[prop] = __.deepExtend(__.clone(obj[prop]), source[prop]);
				}
			} else {
				obj[prop] = source[prop];
			}
		}
	});
	return obj;
}});

//create element function from modernizr 2.8.3 so we can use some of their test whitout the full library.
//https://github.com/Modernizr/Modernizr/blob/9d6ed728f17a1e58d6eef3266eea4613ef459ea1/src/createElement.js
var createElement = function() {
	if (typeof document.createElement !== 'function') {
		// This is the case in IE7, where the type of createElement is "object".
		// For this reason, we cannot call apply() as Object is not a Function.
		return document.createElement(arguments[0]);
	} else {
		return document.createElement.apply(document, arguments);
	}
};

//HTML5 VIDEO SUPPORT DETECTION
//Detect if the specified video format is supported.
//Adapted from modernizr 2.8.3 video test
//https://github.com/Modernizr/Modernizr/blob/master/feature-detects/video.js
//Take a format[string] and return a bool
__.mixin({
	videoFormatIsSupported: function(videoFormat){
		var codecs = {
				ogg:  'video/ogg; codecs="theora"',
				h264: 'video/mp4; codecs="avc1.42E01E"',
				webm: 'video/webm; codecs="vp8, vorbis"',
				vp9:  'video/webm; codecs="vp9"',
				hls:  'application/x-mpegURL; codecs="avc1.42E01E"'
			},
			elem = createElement('video'),
			bool = false;

		var codec = __.find(codecs, function(v,k){
			return k == videoFormat;
		});

		if(codec){
			try{
				if ( bool = !!elem.canPlayType ) {
					bool = elem.canPlayType(codec).replace(/^no$/,'');
				}
			} catch(e){}
		}

		return !!bool;
	}
});

//extract the filename from a path.
__.mixin({ pathToFileName: MHP1138.pathToFileName });

//get the value of a querystring or return null if it don't exist.
__.mixin({ getParameterByName: MHP1138.getParameterByName });

//extract file extention from complete path or filename
__.mixin({
	extractFileExtention: function(path){
		return path.split('?')[0].split('.').pop();
	}
});

//determine if the string is a path
//return true if it found either a slash or a dot
__.mixin({
	isPath: function(string){
		return /.*(\/.*|\..*)+/.test(string);
	}
});

//CLASSLIST SUPPORT FOR IE9 AND LESS
//Redirect to classList methods on modern browser where classList issupported
//Use some regex to emulate the same stuff where classList is not supported
__.mixin((!__.isUndefined(document.documentElement.classList)) ? {
	addClass: function(e, name){
		e.classList.add(name);
	},
	removeClass: function(e, name){
		e.classList.remove(name);
	},
	hasClass: function(e, name){
		return e.classList.contains(name);
	},
	toggleClass: function(e, name){
		e.classList.toggle(name);
	}
} : {
	addClass: function(e, name){
		if (!__.hasClass(e, name))
			e.className += (e.className ? ' ' : '') + name;
	},
	removeClass: function(e, name){
		if (__.hasClass(e, name))
			e.className = e.className.replace(new RegExp('(^|\\s)*' + name + '(\\s|$)*', 'g'), '');
	},
	hasClass: function(e, name){
		return new RegExp('(^|\\s)' + name + '(\\s|$)').test(e.className);
	},
	toggleClass: function(e, name){
		( __.hasClass(e, name) ? __.removeClass : __.addClass )(e, name);
	}
});

//filter and return only the video resolution that have a valid numerical key and a string as a value
__.mixin({
	filterVideoResolution: function(sources){
		return __.filter(__.keys(sources), function(resolution){
			return !__.isNaN(parseInt(resolution))
				&& __.isString(sources[resolution])
				&& sources[resolution].length
				&& __.isPath(sources[resolution]);
		});
	}
});

// this function clean the memory when you delete elements to prevent a memory leak on IE7-9
// http://javascript.crockford.com/memory/leak.html
__.mixin({
	purge: function(d){
		var a = d.attributes, i, l, n;
		if (a) {
			for (i = a.length - 1; i >= 0; i -= 1) {
				n = a[i].name;
				if (typeof d[n] === 'function') {
					d[n] = null;
				}
			}
		}
		a = d.childNodes;
		if (a) {
			l = a.length;
			for (i = 0; i < l; i += 1) {
				__.purge(d.childNodes[i]);
			}
		}
	}
});

__.mixin({
	capitalize: function(str, lowercaseRest) {
		str = '' + str;
		var remainingChars = !lowercaseRest ? str.slice(1) : str.slice(1).toLowerCase();

		return str.charAt(0).toUpperCase() + remainingChars;
	}
});

MHP1138.detector = (function(){
	var devicesType = ['desktop','mobile','tablet','tv'];
	var ready = false;
	var deviceType = null;
	var ua = null;
	var classList = [];
	var currentBrowser = {};
	var strings = {};
	var prefix = '';

	var controller = {
		init: init,
		getBrowser: getBrowser,
		generateClassList: function(element){
			generateClassList(element);
		}
	};

	strings.desktop = {
		ie:      /(?:WOW64.+rv:|MSIE\s)(\d+\.*\d*)(?!.*Firefox)/,         // https://regex101.com/r/iV6wT3/2
		chrome:  /(?:Chrome\/)(\d+\.\d+\.\d+\.*\d+)?/,                    // https://regex101.com/r/hG7aI5/2
		safari:  /(?:Version\/|Safari )(\d+\.\d+\.*\d*)/,                 // https://regex101.com/r/xA3nJ3/1
		firefox: /(?:[Ff]irefox(?:\/| |\(|)(\d*\.\d\.*\d*\.*\d*)*)/,      // https://regex101.com/r/xB2tR2/1
		opera:   /(?:Opera(?:\s|\/))(\d+\.*\d*)?/,					      // https://regex101.com/r/yO2pS0/1
		playstation: /playstation/i,
		xbox: /xbox/i

	};

	strings.mobile = {
		safari:  strings.desktop.safari,
		chrome:  /(?:CriOS\/|Chrome\/)(\d+\.\d+\.\d+\.*\d+)(?!.*OPR)/,    // https://regex101.com/r/qY1lR0/3
		opera:   /(?:OPR\/|Opera(?:\s|\/))(\d+\.\d+\.*\d*\.*\d*)/,        // https://regex101.com/r/cO9dX1/1
		firefox: /(?:Firefox|Fennec|FxiOS)(?:\/)((\d*\.\d\.*\d*\.*\d*))/, // https://regex101.com/r/xB2tR2/2
		ie:      /(?:(?:IEM|iem)obile|MSIE|Edge)(?:\/|\s)(\d+\.*\d*)/,    // https://regex101.com/r/mH9uM0/1
		uc:      /(?:UCBrowser\/|UCWEB\/)(\d+\.\d+\.*\d*\.*\d*)/,         // https://regex101.com/r/lF6lM7/1
		ios:     /iPhone|iPad|iPod/i,
		android: /Android/i
	};

	strings.tablet = {
		safari:  strings.desktop.safari,
		chrome:  strings.mobile.chrome,
		ios:     strings.mobile.ios,
		android: strings.mobile.android,
		ie:      false
	};

	function init(device, classPrefix){
		prefix = classPrefix;

		if( isValidType(device) ){
			deviceType = device;
			ua = navigator.userAgent;
		}
		createIsFunctions();
	}

	function createIsFunctions(){
		//Browser
		__.each( strings[deviceType], function(regex, browserName){
			controller['is' + __.capitalize(browserName)] = function(){
				return !!ua.match(strings[deviceType][browserName]);
			};
		});

		//Devices type
		__.each( devicesType, function(deviceName){
			controller['is' + __.capitalize(deviceName)] = function(){
				return deviceName == deviceType;
			};
		});
	}

	function cleanVersion(version){
		return !__.isUndefined(version) ? version.split('.')[0] : version;
	}

	function getBrowser(){
		if( __.isEmpty(currentBrowser) ){
			var detail = {};

			__.each( strings[deviceType], function(regex, browserName){
				if( controller['is' + __.capitalize(browserName)]() ){
					detail = [ browserName, ua.match(strings[deviceType][browserName])[1] ];
				}
			});

			currentBrowser = {
				name: detail[0],
				type: deviceType,
				version: cleanVersion(detail[1]),
				fullVersion: detail[1]
			};
		}

		return currentBrowser;
	}

	function generateClassList(element){
		var browser = getBrowser();

		if( !__.isUndefined(browser.name) )
			__.addClass(element, prefix + browser.name);

		if( !__.isUndefined(browser.type) )
			__.addClass(element, prefix + browser.type);

		if( !__.isUndefined(browser.version) )
			__.addClass(element, prefix + browser.name + browser.version);
	}

	function isValidType(type){
		return !!~__.indexOf(devicesType, type);
	}

	return controller;
})();